import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";

const routes: Routes = [
  // { path: "", redirectTo: "list", pathMatch: "full"  as Route['pathMatch'] },
  // {
  //   path: "list",
  //   component: MediaManagerListComponent,
  // },
];
@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class MediaManagerRoutingModule {}
